import './styles/main.scss'
import SiteSlider from "./modules/SiteSlider"
import SliderHeader from "./modules/SliderHeader"

// Instantiate a new object using our modules/classes
const allSlider = new SiteSlider()
const headSlider = new SliderHeader()
